import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

const Error = () => {
    const location = useLocation();
    let errorMessage = location.state?.props;

    if (location.pathname === '/oidcnotfound') {
        errorMessage = 'The account you used does not have permissions to access eCamera.';
    }

    return (
      <div>
          <div className="container-fluid">
              <div className="row">
                  <div className="col-lg-12 info-page">
                        <div>Cannot proceed. If assistance is needed, contact system administrator.</div>
                        <br />                     
                        <div className="error-text">{errorMessage}</div>
                        <div style={{ fontSize: '14px', marginTop: '5px', paddingRight: '12px' }}>
                            <Link to="/logout">Please click here to logout and try again</Link>
                        </div>
                        
                  </div>
              </div>
          </div>
      </div>
    )
}

export default Error;
